import {
    ValidationContext,
    ValidatorFunctionContext,
} from './validation-context';
import { Validator } from './validator';

export class ValidationError {
    constructor(
        readonly key: string,
        readonly context: ValidatorFunctionContext,
        readonly validator: Validator
    ) {}

    get errorMessage(): string {
        return this.getErrorMessage();
    }

    getErrorMessage(displayName?: string): string {
        const ctx = {
            ...this.context,
            displayName:
                displayName ||
                this.context.displayName ||
                this.context.propertyName,
        };

        return this.formatMessage(ctx.messageTemplate, ctx);
    }

    protected formatMessage(
        template: string,
        context: ValidationContext
    ): string {
        return template.replace(/%([\w|\.]+)%/g, (match, p1) =>
            this.getPropertyValue(context, p1)
        );
    }

    protected getPropertyValue(obj: any, path: string): any {
        const propertyPath = path && path.split('.');
        if (propertyPath && propertyPath.length === 1) {
            return obj[propertyPath[0]];
        }

        if (propertyPath && propertyPath.length > 1) {
            return this.getPropertyValue(
                obj[propertyPath[0]],
                propertyPath.slice(1).join('.')
            );
        }

        return '';
    }
}
